import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';

var Config = require('../../../config');


class Unit extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.getFractioning = this.getFractioning.bind(this);
		
		this.state = {
			unit_number:"",
			require_number:false,
			results:[],
			blood_bags_id:""
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		var submenu = this.props.search !== "" ? this.props.search : this.props.match.path.replace('/', '');
		this.setState({submenu:submenu})
	}

	handleChange(e){
		this.setState({
			[e.target.name] : e.target.value
		});

		if(e.target.id !== null){
			var control = document.getElementById(e.target.id);
			if(control !== null){
			  if(control.required && control.className.includes('error')){
				control.classList.remove('error');
			  }else if(control.required && e.target.value===""){
				control.classList.add('error');
			  }
			}
		}
	}

	onSearch(){
		if(this.state.submenu === 'fractioning'){
			this.getFractioning();
		}
	}

	getFractioning(){

		if(this.state.unit_number === ''){
			this.setState({
				require_number:true
			});

			swal('Error', 'Número de unidad es requerido', 'error');
		}else{
			this.setState({
				require_number:false
			});
			this.waiting_modal.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'units/to_division?unit_number='+this.state.unit_number+
				'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{
				method : 'GET',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				if(res.ok){
					return res.json()
				}
				else{
					res.text().then(function(result){
						swal(result, "",'warning');
					})
					
				}					
			})
			.then(response => {
				if(response === undefined ){
					this.setState({
						results: []
					});

					this.waiting_modal.handleClose();
					
					this.props.sendData(this.state.results);
				}else{
					this.setState({
						results: response
					});

					this.waiting_modal.handleClose();

					this.props.sendData(this.state.results);
				}	
			});
		}
	}


	render(){
		const {t} = this.props;
		return (
			<div className="col-xs-12">
				<div className="col-xs-12 col-sm-3 col-md-2" >
					<span className="span-min">Número de Unidad</span>
					<input type="text" name="unit_number" id="unit_number" value={this.state.unit_number || ""} 
						onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} 
						className={this.state.require_number ? "form-control error" : "form-control"} />
				</div>
				<div className="col-xs-12 col-sm-1"style={{paddingTop:"12px"}}>
        			<button style={{float:"right", fontSize:"1em"}} className="btn btn-info" type="button" 
        				onClick={this.onSearch.bind(this)}>
        				{t('content.generics.buttons.search')}
        			</button>
				</div>

				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Unit);